type ImportType = {
  project: string
  code: string
  items: {
    project: string
    code: string
    operations: {
      opGroup: string
      items: {
        opGroup: string
        time: number
        salary: number
        units: number
        normative: number
        plannedAt: string
        plannedTo: string
      }[]
    }[]
  }[]
}

export function csvToJson(csv: string): ImportType {
  const [, ...lines] = csv.split("\n")
  const items: any[] = []
  let item: null | any = null
  let operation: null | any = null

  lines.forEach((line) => {
    const processedLine = line.replace(/"([^"]*?)"/g, (match) =>
      match.replace(/,/g, ";")
    )

    const [proj, op, sub, , amount, time, plannedAt = "", plannedTo = ""] =
      line.split(/,|;/)
    // processedLine
    //   .replace(/^"(.*)"$/, "$1")
    //   .split(/,|;/)

    if (proj && op) {
      item = {
        project: proj,
        code: "",
        operations: [],
      }
      items.push(item)
    }

    if (op || sub) {
      if (item) {
        if (op) {
          operation = {
            opGroup: op,
            items: [],
          }
          item.operations.push(operation)
        }
        if (sub) {
          const units = +amount
          if (operation) {
            operation.items.push({
              opGroup: sub,
              time: 0,
              salary: 0,
              units,
              normative: +time,
              plannedAt: plannedAt.match(
                /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/
              )
                ? plannedAt
                : "",
              plannedTo: plannedTo.match(
                /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/
              )
                ? plannedTo
                : "",
            })
          }
        }
      }
    }
  })

  return {
    project: "",
    code: "",
    items,
  }
}
